import messageChannelService from '../message-channel.service'
import { logInfo, logError } from '../../../utilities/pinpad-v2/logger'

class SessionService {
  constructor() {
    this._credentials = null
    this._userInfo = null
    this._terminalInfo = null
    this._environment = null
  }

  // ===== Cache Setters =====

  setCredentials(credentials) {
    this._credentials = credentials
    logInfo('Session credentials cached', { user: credentials?.Usuario })
  }

  setUserInfo(userInfo) {
    this._userInfo = userInfo
    logInfo('Session userInfo cached', { company: userInfo?.bs_company, branch: userInfo?.bs_branch })
  }

  setTerminalInfo(terminalInfo) {
    this._terminalInfo = terminalInfo
    logInfo('Session terminalInfo cached', { marca: terminalInfo?.marca, modelo: terminalInfo?.modelo })
  }

  setEnvironment(environment) {
    this._environment = environment
    logInfo('Session environment cached', { environment })
  }

  // ===== Cache Getters =====

  getCredentials() {
    return this._credentials
  }

  getUserInfo() {
    return this._userInfo
  }

  getTerminalInfo() {
    return this._terminalInfo
  }

  getEnvironment() {
    return this._environment
  }

  // ===== Existing Methods =====

  async initValues(params) {
    const missing = []
    if (!params?.Ambiente) missing.push('Ambiente')
    if (!params?.dataUserConfig) missing.push('dataUserConfig')
    if (!params?.dataPpConfig) missing.push('dataPpConfig')

    if (missing.length) {
      const error = new Error(`Missing required parameters: ${missing.join(', ')}`)
      error.code = 'INVALID_PARAMETERS'
      throw error
    }

    try {
      logInfo('Restoring PinPad session with initValues', { environment: params.Ambiente })
      return await messageChannelService.sendMessage('initValues', {
        Ambiente: params.Ambiente,
        dataUserConfig: params.dataUserConfig,
        dataPpConfig: params.dataPpConfig
      }, 30000)
    } catch (error) {
      logError('initValues failed', error, { environment: params.Ambiente })
      throw error
    }
  }

  hasStoredSession() {
    return !!(
      localStorage.getItem('datosPinPad') &&
      localStorage.getItem('datosusuario') &&
      localStorage.getItem('user')
    )
  }

  getStoredSession() {
    if (!this.hasStoredSession()) return null

    try {
      const datosPinPad = JSON.parse(localStorage.getItem('datosPinPad'))
      const datosusuario = JSON.parse(localStorage.getItem('datosusuario'))
      const user = localStorage.getItem('user')

      return {
        dataPpConfig: datosPinPad?.dataPpConfig,
        dataUserConfig: datosusuario?.dataUserConfig,
        user
      }
    } catch (error) {
      logError('Failed to parse stored PinPad session', error)
      return null
    }
  }
}

const sessionService = new SessionService()

export default sessionService
